export default class CollapseElement {
  constructor(element) {
    let triggerElementClass = element.getAttribute("data-trigger-element");
    let triggerElements = element.getElementsByClassName(triggerElementClass);

    function collapse() {
      // Set cookie for actionbar
      let nodeID = element.getAttribute("data-node-id");
      if (nodeID) {
        var d = new Date();
        d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
        var expires = "expires=" + d.toUTCString();
        document.cookie =
          "actionbar_" + nodeID + "=seen;" + expires + ";path=/";
      }

      element.style.height = "0px";
      element.style.display = "none";
    }

    Array.from(triggerElements).forEach((triggerElement) => {
      triggerElement.addEventListener("click", collapse, false);
    });
  }
}
